import { render } from "./ActionListItemStakeTokens.vue?vue&type=template&id=2d4a4b13"
import script from "./ActionListItemStakeTokens.vue?vue&type=script&lang=ts"
export * from "./ActionListItemStakeTokens.vue?vue&type=script&lang=ts"
script.render = render

export default script